import { useEffect } from "react"
import { PageViewAttributes } from "../../analytics/interfaces"
import { extractUrlParams } from "../../utils"
import { AppClientCodes, isWebApp } from "../../utils/auth.util"
import analyticsManagerInstance from "../../analytics/analyticsManagerInstance"

/**
 * Custom hook to track screen views with Mixpanel, intended to run only once on component mount.
 * @param {Object} eventProperties Properties related to the screen view event.
 */

const useTrackScreenView = (eventProperties: PageViewAttributes) => {
	useEffect(() => {
		const { appCode } = extractUrlParams(window.location.search)
		const isWeb = isWebApp(appCode as AppClientCodes)
		if (isWeb) {
			analyticsManagerInstance.trackPageLoad(eventProperties)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])
}

export default useTrackScreenView
